export const EVENTS = {
  DIALOG: {
    OPENED: 'dialog.opened',
    CLOSED: 'dialog.closed',
    BACK_ACTION_CLOSE_REQUIRED: 'dialog.back_action_close_required',
    PROMPT_REQUESTED: 'dialog.PROMPT_REQUESTED',
    AMOUNT_REQUESTED: 'dialog.AMOUNT_REQUESTED',
    MOBILE_TOPUP_REQUESTED: 'dialog.MOBILE_TOPUP_REQUESTED',
    ESIM_REQUESTED: 'dialog.ESIM_REQUESTED',
  }
};
